import { Observable, forkJoin } from 'rxjs'
import { FirewallService } from '@surgetech-eu/core'
import { map } from 'rxjs/operators'
import { Inject, Injectable } from '@angular/core'

export const uploadDamMedia = 'uploadDamMedia'
export const manageDamUsers = 'manageDamUsers'
export const accessDam = 'accessDam'
export const accessDamContent = 'accessDamContent'
export const accessDamLogActivity = 'accessDamLogActivity'
export const accessDamPop = 'accessDamPop'

@Injectable()
export class RightsResolver {
  constructor(@Inject('surge.core.firewall') private firewall: FirewallService) {}

  resolve(): Observable<{ [p: string]: boolean }> | Promise<{ [p: string]: boolean }> | { [p: string]: boolean } {
    const actions = [uploadDamMedia, manageDamUsers, accessDam, accessDamContent, accessDamLogActivity, accessDamPop]

    return forkJoin(actions.map(a => this.firewall.allow(a))).pipe(
      map(allow => {
        const rights = {}
        actions.forEach((a, i) => (rights[a] = allow[i]))
        return rights
      })
    )
  }
}
